<template>
  <div class="erropageBox">
    <Header></Header>
    <div class="erropage">
      <div class="silingsi">
        <img src="../assets/images/404.png" alt="" />
      </div>
      <p class="p1">不好意思，页面暂时丢失了！</p>
      <button @click="shouye">返回首页</button>
      <p class="p2">欢迎拨打客服热线</p>
      <p class="p3">400-800-8772</p>
      <p class="p4">客服将热情回应您的呼唤！</p>
      <div class="di">
        <img src="../assets/images/dibu.png" alt="" />
      </div>
    </div>
    <!-- 底部 -->
    <Bottom></Bottom>
  </div>
</template>
<script>
import Header from "./Header.vue";
import Bottom from "../components/Foot";
export default {
  components: {
    Header,
    Bottom,
  },
  data() {
    return {};
  },
  methods: {
    shouye() {
      this.$router.push("/");
    },
  },
};
</script>
<style lang="scss" scoped>
.erropageBox {
  margin-top: 140px;
  .erropage {
    width: 100%;
    height: 1058px;
    padding-top: 218px;
    box-sizing: border-box;
    text-align: center;
    position: relative;
    .silingsi {
      width: 297px;
      height: 209px;
      margin: auto;
      margin-bottom: 77px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .p1 {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #302c48;
      margin-bottom: 50px;
    }
    button {
      width: 201px;
      height: 75px;
      background: #f7901e;
      box-shadow: 0px 5px 9px 0px rgba(15, 15, 15, 0.19);
      border-radius: 38px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 60px;
    }
    .p2 {
      font-size: 21px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #62616b;
      margin-bottom: 15px;
    }
    .p3 {
      font-size: 21px;
      font-family: PingFang SC;
      font-weight: 400;
      margin-bottom: 15px;
      color: #3f86fb;
    }
    .p4 {
      font-size: 21px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #62616b;
      z-index: 99;
    }
    .di {
      z-index: 1;
      width: 430px;
      height: 247px;
      position: absolute;
      bottom: 0;
      left: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>